import { useEffect, useState } from "react";

export function UserDetailData(){
    const [userData, setUserData] = useState({});
    const [dbddata, SetDbddata] = useState({});
    const [loading, setLoading] = useState(false);
    

    const empdataHomePage = async () => {
        try {
            const res = await fetch('/user/empmasterdata');
            const empdata = await res.json();        
            setUserData(empdata);            
        } catch (err) {
            console.log(err);
            
        }
    
    }

    const currentdatadate = async () => {
        try {
          const dbres = await fetch('/homedb/dashboardata');
          const dbresdata = await dbres.json();
          SetDbddata(dbresdata);
          
        } catch (error) {
          console.log(error);
        }
      }
      

    useEffect (() => {
        setLoading(true)
        empdataHomePage();
        currentdatadate();      
        setLoading(false);
        // pageload();  
    },[])


    return{
        userData, dbddata, loading
    }
}